import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, map, Observable, takeWhile } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ChatGptService {
  endpoint = environment.nodeEndpoint;
  histroyEndpoint = environment.apiURL;
  gcpEndPoint = environment.podurl;

  private isStreaming = signal(false);
  constructor(private http: HttpClient) { }

  getBingImages(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/search-bing-images`, payload);
  }

  sendChatCompletionRequest(messages: any) {
    return this.http.post(`${this.endpoint}chat-completion`, { message: messages });
  }

  sendChatCompletionRequest2(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/chat-bot`, payload);
  }

  sendChatCompletionRequestConfig(payload: any) {
    return this.http.post(`${this.endpoint}chat-completion`, payload);
  }

  crateHistory(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/new_chat`, payload);
  }

  updateHistory(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/chat_update`, payload);
  }

  editChatTitle(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/edit_title`, payload);
  }

 
  getUserHistory() {
    return this.http.get(`${this.histroyEndpoint}/chat_history`);
  }

  deleteUserHistory(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/delete_p`, payload);
  }

  getDetailHistory(payload: any) {
    return this.http.post(`${this.histroyEndpoint}/old_chat`, payload);
  }

  


  streamChatCompletionRequest(payload: any,  accessToken: String | null) {
    this.isStreaming.set(true);
    return new Observable(observer => {
      let retryAttempted = false;

      const makeRequest = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${this.histroyEndpoint}/chat-bot-stream-new`, true);
        xhr.setRequestHeader('authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Auth-platform', 'mobile');
        xhr.setRequestHeader('old-ui', 'prod');

        let buffer = '';
        let lastProcessedIndex = 0;

        xhr.onprogress = () => {
          const newData = xhr.responseText.slice(lastProcessedIndex);
          buffer += newData;
          lastProcessedIndex = xhr.responseText.length;

          let newlineIndex;
          while ((newlineIndex = buffer.indexOf('\n')) !== -1) {
            const chunk = buffer.slice(0, newlineIndex).trim();
            buffer = buffer.slice(newlineIndex + 1);

            if (chunk) {
              try {
                const data = JSON.parse(chunk);
                observer.next(data);
              } catch (error) {
                console.error('Error parsing chunk:', chunk, error);
              }
            }
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            if (buffer.trim()) {
              try {
                const data = JSON.parse(buffer.trim());
                observer.next(data);
              } catch (error) {
                console.error('Error parsing final chunk:', buffer, error);
              }
            }
            observer.complete();
          } else if (xhr.status === 401 && !retryAttempted) {
            retryAttempted = true;
            this.refreshToken().subscribe((response: any) => {
              const newToken = response.data.id_token;
              localStorage.setItem('token', newToken);

              let refresh_token = response.data.refresh_token;
              localStorage.setItem('refresh_token', refresh_token);

              makeRequest();
            }, error => {
              observer.error(new Error('Failed to refresh token'));
              this.isStreaming.set(false);
            });
          } else {
            observer.error(new Error(`HTTP error! status: ${xhr.status}`));
            this.isStreaming.set(false);
          }
        };

        xhr.onerror = () => {
          observer.error(new Error('XHR error'));
          this.isStreaming.set(false);
        };

        xhr.send(JSON.stringify(payload));
      };

      makeRequest();

      return () => {
        this.isStreaming.set(false);
      };
    }).pipe(
      takeWhile(() => this.isStreaming())
    );
  }

  refreshToken() {
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();
      const refresh_token = localStorage.getItem('refresh_token');
      xhr.open('GET', `${this.endpoint}refresh?refresh_token=${refresh_token}`, true);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          observer.next(response);
          observer.complete();
        } else {
          observer.error(new Error(`HTTP error! status: ${xhr.status}`));
        }
      };

      xhr.onerror = () => {
        observer.error(new Error('XHR error'));
      };

      xhr.send();
    });
  }


  stopStreaming() {
    this.isStreaming.set(false);
  }

  get streaming() {
    return this.isStreaming();
  }

  
  // gcp api call
  uploadChatFile(payload: any) {
    return this.http.post(`${this.gcpEndPoint}/upload`, payload);
  }

  getChatResponse(payload: any): Observable<any> {
    const url = `${this.gcpEndPoint}/chat`;


    return this.http.post(url, payload, { responseType: 'text' }).pipe(
      map(response => {
        const messages = response.split('\n').filter(chunk => chunk.trim()).map(chunk => JSON.parse(chunk));
        return messages;
      }),
      catchError(error => {
        console.error('HTTP error:', error);
        throw new Error(`HTTP error! status: ${error.status}`);
      })
    );
  }




}
